export interface TrySimplelanguages {
  Csharp: string
  Java: string
  JavaScript: string
  PHP: string
  Python: string
}

export interface ICredentials {
  username: string,
  password: string,
}

export interface ILogIn {
  username: string,
  password: string,
}

export type IResponse = {
  statusCode: number,
  message: string,
  /**
   * Stable DPI-xxxx code. null on success, on 429 rate-limit responses and on the
   * Get Token 404; a 401 has no body at all, so the key may be absent.
   */
  errorCode?: string | null,
  data: any
}

export enum PaymentMethod {
  CASH = "Cash",
  WALLET = "Wallet",
  BANK = "Bank"
}

export enum SenderTypes {
  INDIVIDUAL = "Individual",
  CORPORATE = "Corporate",
  CHARITY = "Charity"
}

export interface IBankDetails {
  accountId: string;
  bankCode?: string;
  bankSwift?: string;
}

export interface IReceiver {
  id?: string;
  name: string;
  destinationAgent: string;
  phone: string;
  address?: string;
  /** Required when `commission` is supplied; a destination agent may also require it. */
  nationality?: string;
  receiverRelationship?: string;
  additionalField1?: string;
  additionalField2?: string;
}

export interface ISender {
  id: string;
  name: string;
  /** Optional; when supplied it must be 7 to 15 characters. */
  phone?: string;
  city: string;
  address: string;
  country: string;
  state?: string;
  postCode?: string;
  nationality?: string;
  documentType: string;
  documentNumber: string;
  issueDate: string; // date-time
  expireDate: string; // date-time
  dateOfBirth: string; // date-time
  placeOfBirth?: string;
  gender?: string;
  occupation?: string;
  senderType: SenderTypes;
  sourceOfFund?: string;
  additionalField1?: string;
  additionalField2?: string;
}

export interface IRemittanceDto {
  requestUniqueId: string;
  paymentMethod: PaymentMethod;
  sender: ISender;
  receiver: IReceiver;
  bankDetails?: IBankDetails;
  amount: number;
  origRefNumber: string;
  currencyCode?: string;
  purpose?: string;
  narration?: string;
  payoutAmount?: number;
  bankAccount?: string;
  commission?: number;
}

export type ISendRemittanceRequest = IRemittanceDto;

export interface ICancelForm {
  RefundType: string,
  ReasonForCancellation: string,
  TransactionId: string
}

export interface ICancelRemittanceRequest {
  ttno: string;
  refundType: string; // "FULL" | "NET"
  reasonForCancellation: string;
}

export interface IUpdateBeneficiaryDetailsRequest {
  ttno: string;
  beneficiaryName: string;
  beneficiaryMobile: string;
}

export interface IGetExchangeRatesRequest {
  currency: string;
}


export type SearchForm = {
  TransactionId: string,
  SenderName: string
  ReceiverName: string,
  ReceiverPhone: string,
  SendingCountry: string
}

export interface IGetReadyTransactionRequest {
  SearchForm: SearchForm
}

export interface IGetTransactionDetailsRequest {
  ttno: string;
}

export interface IGetAgentsRequest {
  countryCode: string
}

export interface IGetCountryServicesRequest {
  countryCode: string;
}

export interface IGetBanksByCountryRequest {
  countryCode: string;
}

export interface IValidateMobileRequest {
  mobileNo: string,
  Entity: string
}

export interface IValidateBankRequest {
  
  AccountId: string
  Entity: string
}

export enum AccountEntity {
  EDAHAB = "EDAHAB",
  MPESA = "MPESA",
  UGANDA = "UGANDA",
  TANZANIA = "TANZANIA",
  BANGLADESH = "BANGLADESH",
  DMT = "DMT",
  DBI = "DBI",
  EAB = "EAB",
  PESALink = "PESALink",
  ABC = "ABC"
}

export interface IValidateAccountRequest {
  account: string;
  entity: AccountEntity;
  type: string;
  /** Used only for PESALink and ABC lookups; ignored for other entities. */
  code?: string;
}

export interface APICredentials {
  id: string;
  apiKey: string;
  clientSecret: string;
  isActive: boolean;
  createdAt: string;
}

export interface TransactionDetails {
  // Transaction details fields
}